var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 13.1256C18.125 11.399 16.726 10 15.0006 10C13.274 10 11.875 11.399 11.875 13.1256C11.875 14.851 13.274 16.25 15.0006 16.25C16.726 16.25 18.125 14.851 18.125 13.1256Z",
    stroke: "#47AD1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9994 26.25C13.5013 26.25 5.625 19.873 5.625 13.2041C5.625 7.98329 9.82138 3.75 14.9994 3.75C20.1774 3.75 24.375 7.98329 24.375 13.2041C24.375 19.873 16.4975 26.25 14.9994 26.25Z",
    stroke: "#47AD1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.edc8108cc8cb32b77f4fadea9f738255.svg";
export { ForwardRef as ReactComponent };